module.exports = __webpack_public_path__ + "static/media/publishIcon.91123496.svg";